import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { FinancesOverview } from "web_myplann/Finances/Pages/FinancesOverview";
import { FinancesOverviewV2 } from "web_myplann/Finances/Pages/FinancesOverviewV2";

export const FinancesOverviewPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <FinancesOverviewV2 /> : <FinancesOverview />;
};
